(ns app.front.view.group.admin.fees.schedule.schedule-events
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.fees.reversal-methods.events :as rm-events]
            [app.front.view.group.admin.fees.template.template-core :as fee-template-management]
            [app.front.view.group.admin.form-field-selection :as ff-selection]
            [app.front.view.navigation :as navigation]
            [core.front.routing :as routing]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::initialize-db
  (fn [db [_ authority-group-id]]
    (assoc db ::fees {:authority-group-id authority-group-id})))


(rf/reg-event-fx ::fetch-permit-type-configs
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/permit-type-configs
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::permit-type-configs-fetched]}}))


(rf/reg-event-fx ::permit-type-configs-fetched
  (fn [{:keys [db]} [_ status entities]]
    {:dispatch-n [[::entities/merge-entity-db status entities]
                  [::fetch-schedules (-> db ::fees :authority-group-id)]
                  [::ff-selection/fetch-form-fields (-> db ::fees :authority-group-id)]]}))


(rf/reg-event-fx ::open-fee-template-editor
  (fn [{:keys [db]} [_ fee-schedule disabled?]]
    {:db       (assoc-in db [::fees :fee-template-editor-open?] true)
     :dispatch [::fee-template-management/init fee-schedule disabled? [::close-fee-template-editor]]}))


(rf/reg-event-fx ::close-fee-template-editor
  (fn [{:keys [db]} _]
    {:db (p/dissoc-in db [::fees :fee-template-editor-open?])}))


(rf/reg-event-fx ::fetch-schedules
  (fn [{:keys [db]} [_ authority-group-id]]
    {:db           (assoc-in db [::fees :schedules-loading?] true)
     :comm/command {:command    :fee/get-fee-schedules
                    :method     :get
                    :data       {:authority-group-id authority-group-id}
                    :on-success [::fee-schedules-fetch-success]}}))


(rf/reg-event-fx ::fetch-schedule
  (fn [_ [_ _authority-group-id fee-schedule-id]]
    {:comm/command {:command    :fee/get-fee-schedule
                    :method     :get
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::fee-schedule-fetch-success]}}))


(rf/reg-event-fx ::fee-schedules-fetch-success
  (fn [{:keys [db]} [_ status {:keys [fees-enabled? fee-schedules receipt-template]}]]
    (if-not fees-enabled?
      {:dispatch [::routing/reset-view]}
      {:db         (p/dissoc-in db [::fees :schedules-loading?])
       :dispatch-n [[::entities/override-entity-db
                     status
                     (-> fee-schedules
                         (assoc (:db/id receipt-template) receipt-template))]]})))

(rf/reg-event-fx ::fee-schedule-fetch-success
  (fn [{:keys [db]} [_ status {:keys [entities]}]]
    (let [fee-schedule-id            (some #(when (= (:entity/type %) :entity.type/fee-schedule)
                                              (:db/id %))
                                           (vals entities))
          db-without-old-assignments (if fee-schedule-id
                                       (entities/remove-entities-with-filter
                                         db
                                         #(and (:schedule-reversal-method-assignment/schedule %)
                                               (= (:schedule-reversal-method-assignment/schedule %) fee-schedule-id)))
                                       db)]
      {:db       db-without-old-assignments
       :dispatch [::entities/override-entity-db status entities]})))


(rf/reg-event-fx ::save
  (fn [{:keys [db]} [_ fee-schedule-id superdomain-group?]]
    (let [titles           (get-in db [::fees :unsaved-changes fee-schedule-id :fee-schedule :fee-schedule/titles])
          valid-from       (get-in db [::fees :unsaved-changes fee-schedule-id :fee-schedule :fee-schedule/valid-from])
          change-sets      (get-in db [::fees :unsaved-changes fee-schedule-id :fee-structures])
          reversal-changes (get-in db [::fees :unsaved-changes fee-schedule-id :reversal-methods])
          permit-type      (get-in db [::fees :unsaved-changes fee-schedule-id :fee-schedule :fee-schedule/permit-type])]
      {:comm/command {:command    :fee/edit-fee-schedule
                      :method     :post
                      :data       (p/assoc-if {:fee-schedule-id fee-schedule-id}
                                              :change-sets change-sets
                                              :titles titles
                                              :valid-from valid-from
                                              :reversal-methods reversal-changes
                                              :permit-type (when superdomain-group? permit-type))
                      :on-success [::update-success fee-schedule-id :changes-saved]}})))


(rf/reg-event-fx ::update-success
  (fn [{:keys [db]} [_ fee-schedule-id notification]]
    (let [copied? (= notification :fees/schedule-copied)
          event   (if copied?
                    ::fetch-schedules
                    ::fetch-schedule)]
      {:db         (-> db
                       (p/dissoc-in [::fees :unsaved-changes fee-schedule-id])
                       (p/dissoc-in [::fees :schedules-duplicating?])
                       (p/dissoc-in [::fees :schedules-archiving?]))
       :dispatch-n (->> [[event (get-in db [::fees :authority-group-id]) fee-schedule-id]
                         [:notifications/add :toast :success :success notification]]
                        (concat (when copied?
                                  [[::fee-config-tab-changed :fees/active-schedules]])
                                (when (integer? fee-schedule-id)
                                  [[::navigation/scroll-to-id (str "section--" fee-schedule-id)]]))

                        vec)})))


(rf/reg-event-db ::cancel
  (fn [db [_ fee-schedule-id]]
    (p/dissoc-in db [::fees :unsaved-changes fee-schedule-id])))


(rf/reg-event-fx ::copy-fee-schedule
  (fn [{:keys [db]} [_ fee-schedule-id]]
    {:db           (assoc-in db [::fees :schedules-duplicating?] true)
     :comm/command {:command    :fee/copy-fee-schedule
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::update-success fee-schedule-id :fees/schedule-copied]}}))


(rf/reg-event-fx ::archive-fee-schedule.error
  (fn [{:keys [db]} [_ _ {:keys [error]}]]
    {:db       (p/dissoc-in db [::fees :schedules-archiving?])
     :dispatch [:notifications/add :toast :error :error/error error]}))


(rf/reg-event-fx ::archive-fee-schedule
  (fn [{:keys [db]} [_ fee-schedule-id]]
    {:db           (assoc-in db [::fees :schedules-archiving?] true)
     :comm/command {:command    :fee/archive-fee-schedule
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::update-success fee-schedule-id :fees/schedule-archived]
                    :on-done    [::archive-fee-schedule.error]}}))


(rf/reg-event-fx ::unarchive-fee-schedule
  (fn [{:keys [db]} [_ fee-schedule-id]]
    {:db           (assoc-in db [::fees :schedules-archiving?] true)
     :comm/command {:command    :fee/unarchive-fee-schedule
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::update-success fee-schedule-id :fees/schedule-unarchived]
                    :on-done    [::archive-fee-schedule.error]}}))


(rf/reg-event-db ::change-field
  (fn [db [_ fee-schedule-id field value]]
    (assoc-in db [::fees :unsaved-changes fee-schedule-id :fee-schedule field] value)))


(defn find-or-create-changeset [db fee-schedule-id target-path]
  (let [changesets         (get-in db [::fees :unsaved-changes fee-schedule-id :fee-structures])
        existing-changeset (p/find-first changesets #(= (:target-group-config-ids %) target-path))
        changeset          (if existing-changeset
                             existing-changeset
                             {:target-group-config-ids target-path
                              :add                     #{}
                              :remove                  #{}})]
    [changesets changeset]))


(defn update-changeset [changesets target-path updated-changeset]
  (as-> changesets c
        (filter #(not= (:target-group-config-ids %) target-path) c)
        (conj c updated-changeset)))


(defn toggle-fee-template
  "Collects FeeTemplate attachments/detachments like so:
   [{:target-group-config-ids [123456 123457]
     :add    #{1234}
     :remove #{}]"
  [db [_ fee-schedule-id target-path fee-template-id checked?]]
  (let [[changesets changeset] (find-or-create-changeset db fee-schedule-id target-path)
        add-to-changes         #(set (conj % fee-template-id))
        remove-from-changes    #(set (filter (fn [id] (not= id fee-template-id)) %))
        updated-changeset      (-> changeset
                                   (update :add #(if checked?
                                                   (add-to-changes %)
                                                   (remove-from-changes %)))
                                   (update :remove #(if-not checked?
                                                      (add-to-changes %)
                                                      (remove-from-changes %))))
        updated-changesets     (update-changeset changesets target-path updated-changeset)]
    (assoc-in db [::fees :unsaved-changes fee-schedule-id :fee-structures] updated-changesets)))


(rf/reg-event-db ::toggle-fee-template
  toggle-fee-template)



(rf/reg-event-db ::select-permit-type-tuple
  (fn [db [_ fee-schedule-id [selected-permit-type selected-category selected-work-type selected-work-target]]]
    (-> db
        (update-in [::fees :fee-schedules fee-schedule-id] merge (util/mmap selected-permit-type
                                                                            selected-category
                                                                            selected-work-type
                                                                            selected-work-target)))))

(rf/reg-event-db ::fee-item-filter-changed
  (fn [db [_ filter-text]]
    (assoc-in db [::fees :fee-item-filter] filter-text)))

(rf/reg-event-db ::reversal-method-filter-changed
  (fn [db [_ filter-text]]
    (assoc-in db [::fees :reversal-method-filter] filter-text)))

(rf/reg-event-db ::toggle-reversal-method
  (fn [db [_ fee-schedule-id _target-path method-id checked?]]
    (let [path    [::fees :unsaved-changes fee-schedule-id :reversal-methods]
          current (get-in db path {:add {} :remove #{}})
          result  (if checked?
                    (-> current
                        (update :add assoc method-id {})
                        (update :remove disj method-id))
                    (-> current
                        (update :add dissoc method-id)
                        (update :remove conj method-id)))]
      (assoc-in db path result))))

(rf/reg-event-db ::update-reversal-method-nsf-amount
  (fn [db [_ fee-schedule-id _target-path method-id amount]]
    (assoc-in db [::fees :unsaved-changes fee-schedule-id :reversal-methods :add method-id :nsf-amount]
              amount)))

(rf/reg-event-db ::update-reversal-method-nsf-gl-code
  (fn [db [_ fee-schedule-id _target-path method-id gl-code]]
    (assoc-in db [::fees :unsaved-changes fee-schedule-id :reversal-methods :add method-id :nsf-gl-code]
              gl-code)))

(rf/reg-event-fx ::create-new-schedule.success
  (fn [_ [_ authority-group-id _ resp]]
    {:fx [[:dispatch-n [[::fetch-schedules authority-group-id]
                        [::fee-config-tab-changed :fees/active-schedules]
                        [::navigation/scroll-to-id (->> resp ffirst (str "section--"))]]]]}))


(rf/reg-event-fx ::create-new-schedule
  (fn [_ [_ authority-group-id]]
    {:comm/command {:command    :fee/create-fee-schedule
                    :method     :post
                    :data       {:authority-group-id authority-group-id
                                 :data               {}}
                    :on-success [::create-new-schedule.success authority-group-id]}}))


(rf/reg-event-fx ::delete-fee-schedule
  (fn [_ [_ fee-schedule-id]]
    {:comm/command {:command    :fee/delete-fee-schedule
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::entities/merge-entity-db]}}))

(rf/reg-event-fx ::publish-fee-schedule
  (fn [_ [_ fee-schedule-id]]
    {:comm/command {:command    :fee/publish-fee-schedule
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id}
                    :on-success [::update-success fee-schedule-id :fees/schedule-published]}}))


(rf/reg-event-fx ::fee-config-tab-changed
  (fn [{:keys [db]} [_ selected-tab]]
    (let [authority-group-id (get-in db [::fees :authority-group-id])
          fetch-events       (case selected-tab
                               :fees/active-schedules
                               [[::fetch-schedules authority-group-id]
                                [::rm-events/fetch-reversal-methods authority-group-id]]

                               :fees/reversal-methods
                               [[::rm-events/fetch-reversal-methods authority-group-id]]

                               [])]
      {:db         (assoc-in db [::fees :fee-config-tab] selected-tab)
       :dispatch-n fetch-events})))
